import logo from '../../logo.svg';
import ButtonNext from '../../ButtonNext.svg';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { dominioHCFamema } from '../../config/database';
export default function TelaInicial() {
    const [local, setLocal] = useState(null);
    const [nome, setNome] = useState("");
    const [telefone, setTelefone] = useState("");
    const navigate = useNavigate();

    const carregaLocal = () => {
        dominioHCFamema
          .get(`/api/getlocalbyid/${window.location.pathname.substring(1, 10)}`)
          .then((response) => {
            setLocal(response.data);
            localStorage.setItem("local", JSON.stringify(response.data));
          });
    };

    const handleIdentificaPaciente = () => {
        const data ={
            Id_Local: local.Id,
            Nome: nome,
            Telefone: telefone
        }
        dominioHCFamema.post('/api/identificarpaciente', data)
        .then((response) => {
            localStorage.setItem("idIdentificacaoPaciente", response.data.idIdentificacaoPaciente);
            navigate("/perguntas");
        },
        (error) => {
            console.log(error.message);
        });
    }

    useEffect(() => {
        carregaLocal();
    }, []);

    return (
        <div style={{
            display:'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}>
            <h1 style={{
                margin: '34px 2px 2px 2px'
            }}>Avaliação de satisfação</h1>
            <h1 style={{
                margin: '1px 1px',
                textAlign: 'center'
            }}>{local?.Descricao}</h1>
            <img src={logo} style={{
                padding: '40px'
            }} alt="logo"
            onContextMenu={(e) => e.preventDefault()} />
            <spam style= {{
                maxWidth: '60vw',
                textAlign: 'center',
                fontSize: '18px'
            }}>Nome e telefone (opcional).</spam>
            <input style={{
                    height: '29px',
                    width: '297px',
                    left: '35px',
                    top: '538px',
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#ECEEEE',
                    margin: '18px 28px 0 28px',
                    padding: '0 12px'
                }}
                placeholder={'Nome'}
                onChange={(event) => {
                    var aux = event.target.value;
                    event.target.value = aux.toUpperCase();
                    setNome(event.target.value);
                }}
            >
            </input>
            <input style={{
                    height: '29px',
                    width: '297px',
                    left: '35px',
                    top: '538px',
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#ECEEEE',
                    margin: '14px 28px',
                    padding: '0 12px',
                }}
                placeholder={'Telefone'}
                onChange={(event) => {
                    if(event.target.value.length > 14){
                        var aux = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
                        event.target.value = !aux[2] ? aux[1] : '(' + aux[1] + ') ' + aux[2] + (aux[3] ? '-' + aux[3] : '');
                        setTelefone(event.target.value);
                    } else {
                        var aux = event.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,4})(\d{0,4})/);
                        event.target.value = !aux[2] ? aux[1] : '(' + aux[1] + ') ' + aux[2] + (aux[3] ? '-' + aux[3] : '');
                        setTelefone(event.target.value);
                    }
                }}
            ></input>
            <img 
                src={ButtonNext} 
                style={{
                    marginTop: '2px',
                    cursor: 'pointer'
                }} alt="buttonnext" 
                onContextMenu={(e) => e.preventDefault()}
                onClick={ () => handleIdentificaPaciente()}
            />
        </div>
    )
}